import { useQuery } from '@tanstack/react-query';
import { timesheetService } from '@/services/timesheets/timesheetService';
import { timesheetQueryKeys } from './queryKeys';

export const useCompanyProfiles = () => {
  return useQuery({
    queryKey: timesheetQueryKeys.companyProfiles(),
    queryFn: () => timesheetService.getCompanyProfiles(),
    staleTime: 10 * 60 * 1000, // 10 minutes (profiles don't change often)
    gcTime: 30 * 60 * 1000, // 30 minutes
  });
};
